/** Shared SEO copy for static HTML, Helmet, and build-time prerender. */

export const SEO_SITE_NAME = "RotoGPT";
export const SEO_DEFAULT_TITLE = "RotoGPT — AI Fantasy Football Assistant";
export const SEO_DEFAULT_DESCRIPTION =
  "RotoGPT is your AI-powered fantasy football assistant. Get trade analysis, waiver wire picks, start/sit advice, and roster insights for Sleeper, ESPN, Yahoo, and more.";
export const SEO_DEFAULT_KEYWORDS =
  "RotoGPT, fantasy football, AI fantasy assistant, trade analyzer, waiver wire, start sit, Sleeper, ESPN, Yahoo fantasy";
export const SEO_OG_IMAGE = "https://rotogpt.com/RotoGPTlogo.png";
export const SEO_TWITTER_HANDLE = "@RotoGPT";

/** Auth0 callback may be https://rotogpt.com/home — SEO tags must use origin only. */
export const seoSiteOrigin = (baseUrl = "https://rotogpt.com"): string => {
  try {
    return new URL(baseUrl).origin;
  } catch {
    return "https://rotogpt.com";
  }
};

export const buildArticleCanonicalPath = (slugOrId: string): string =>
  `/articles/${encodeURIComponent(slugOrId.trim())}`;

export const buildArticleCanonicalUrl = (slugOrId: string, baseUrl = "https://rotogpt.com"): string =>
  `${seoSiteOrigin(baseUrl)}${buildArticleCanonicalPath(slugOrId)}`;

export const SEO_ARTICLES_LIST_TITLE = "Fantasy Football Articles | RotoGPT";
export const SEO_ARTICLES_LIST_DESCRIPTION =
  "Expert fantasy football analysis, trade insights, waiver wire picks, and roster strategy from RotoGPT.";

export const buildArticlesListCanonicalPath = (): string => "/articles";

export const buildArticlesListCanonicalUrl = (baseUrl = "https://rotogpt.com"): string =>
  `${seoSiteOrigin(baseUrl)}${buildArticlesListCanonicalPath()}`;

export const SEO_FAQ_TITLE = "Fantasy Football FAQ | RotoGPT";
export const SEO_FAQ_DESCRIPTION =
  "Answers to common fantasy football questions about RotoGPT: league connections, pricing, Sleeper, ESPN, Yahoo, trades, waivers, and AI-powered roster advice.";
export const SEO_GLOSSARY_TITLE = "Fantasy Football Glossary | RotoGPT";
export const SEO_GLOSSARY_DESCRIPTION =
  "Fantasy football terms and definitions: roster strategy, scoring, waivers, trades, and advanced metrics explained for RotoGPT users.";

export const buildFaqCanonicalPath = (): string => "/faq";
export const buildGlossaryCanonicalPath = (): string => "/glossary";

export const buildFaqCanonicalUrl = (baseUrl = "https://rotogpt.com"): string =>
  `${seoSiteOrigin(baseUrl)}${buildFaqCanonicalPath()}`;

export const buildGlossaryCanonicalUrl = (baseUrl = "https://rotogpt.com"): string =>
  `${seoSiteOrigin(baseUrl)}${buildGlossaryCanonicalPath()}`;
